export enum IOrderFields {
    NameAndEmail = 'Email',
    CreationDate = 'CreationDate',
    IsLimited = 'IsLimited',
}

export interface IDeleteUserForm {
    userId?: number;
}
